import { Injectable } from '@angular/core';
import { QuickSightClient, GetDashboardEmbedUrlCommand } from '@aws-sdk/client-quicksight';
import { Observable } from 'rxjs';
import { jobDesignationApi } from '../../constants/job-designation-api';
import { HttpClientService } from '../httpClient/httpClient.service';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class QuicksightService {
  private quicksightClient: QuickSightClient;

  cred:any ={
    region: '',
    accessKeyId: '',
    secretAccessKey: '',
    AwsAccountId: '',
    DashboardId: '',
  }

  constructor(private httpClientService: HttpClientService, private httpClient: HttpClient) {
    // this.quicksightClient = new QuickSightClient({
    //   region: this.cred?.region,
    //   credentials: {
    //     accessKeyId: this.cred?.accessKeyId,
    //     secretAccessKey: this.cred?.secretAccessKey
    //   }
    // });
  }

  // async getDashboardEmbedUrl(): Promise<string> {
  //   const params :any = {
  //     AwsAccountId: this.cred?.AwsAccountId,
  //     DashboardId: this.cred?.DashboardId,
  //     IdentityType: 'IAM',
  //     SessionLifetimeInMinutes: 600,
  //     UndoRedoDisabled: false
  //   };

  //   try {
  //     const command = new GetDashboardEmbedUrlCommand(params);
  //     const response = await this.quicksightClient.send(command);
  //     return response.EmbedUrl;
  //   } catch (error) {
  //     console.error('Error getting embed URL:', error);
  //     throw error;
  //   }
  // }

  getDashboardEmbedURLMONGO(): Observable<any> {
    // return this.httpClient.get(
    //     'https://api-pre-prod.crizac.com/v1/api/application/quickSiteApplicationReport',
    // );
    return this.httpClientService.get(
      'v1/api/application/quickSiteApplicationReport',
  );
  }
}